import styled from 'styled-components';

import TickIcon from '../../../../Icons/TickIcon';
import ArrowDownIcon from '../../../../Icons/ArrowDownIcon';

export const GuestDetailsWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  margin-top:${props.theme.spacing.large.l12};

`,
);

export const GuestDetailsInnerWrapDiv = styled.div(
  props => `

  display:${props.display || 'flex'};
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  background-color: ${props.theme.colors.white.base};
  border-radius: 1rem;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
`,
);

export const FormsDIV = styled.div(
  props => `
  border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightdd};
  display:${props.display || 'flex'};
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;`,
);

export const GuestTxtWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
    justify-content:space-between;
    align-items: center;
`,
);

export const VerifiedUserDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  // align-items:center;

`,
);

export const TickDiv = styled(TickIcon)(
  props => `

    width:2rem;
    height:2rem;
    // color: ${props.theme.colors.grey.grey50};
    fill:#63c033;
    margin-right:${props.theme.spacing.base};
`,
);

export const PricingTxtSpan = styled.span(
  props => `
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
    padding-bottom:${props.theme.spacing.small.s5};
`,
);

export const PricingSubTxtSpan = styled.span(
  props => `
    color: ${props.theme.colors.grey.light9b};
    font-size:${props.theme.font.large.font13};
    span {
      padding-left: ${props.theme.spacing.small.s5};
    }
`,
);

export const EditLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.large.font16};
  font-weight: bold;
  padding-right:${props.theme.spacing.base};

  color: ${props.theme.colors.goBrand.blue};
  &:hover{
    color: ${props.theme.colors.goBrand.blue};
  }
`,
);

export const CircularDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:2.6rem;
  height:2.6rem;
`,
);

export const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
      width:1rem;
      height:1rem;
      fill: ${props.theme.colors.blue.base};
      margin-top:${props.theme.spacing.small.s8};
      margin-left:${props.theme.spacing.small.s8};
      position:absolute;
      transform: ${props.transformstyle};
      transition: transform 0.5s;
  `,
);

export const PayBtnWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content: center;


`,
);

export const PayTxtSpan = styled.span(
  props => `
  font-family:${props.theme.font.fontFamily};
  font-size:${props.theme.font.large.font18};
  font-weight:bold;
  text-transform: ${props.theme.font.textTransform.upper};
`,
);

export const CustomButton = styled.button(
  props => `
  width: ${props.width || '35rem'};
  display: flex;
  cursor: pointer;
  justify-content: center;
  box-shadow: 0 1px 7px 0 rgba(0,0,0,0.2);
  background-image: linear-gradient(96deg,#53b2fe 1%,#065af3 129%);
  color: ${props.theme.colors.white.base};
  padding: ${props.padding || props.theme.spacing.large.l20};
  border: none;
  border-radius: 34px;
  margin: ${props.theme.spacing.large.l15} auto;
  outline: none;
`,
);

export const GocashCheckBox = styled.input(
  props => `
  display: inline-flex;
  width:24.7rem;

  `,
);